import React from 'react';
import { getAgencyConfig } from '../config/agency';

const Header = () => {
  const agencyConfig = getAgencyConfig();

  return (
    <header className="app-header">
      <div className="header-content">
        <div className="header-left" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img 
            src="/vulcan-logo.png" 
            alt="Vulcan Tech" 
            style={{ 
              height: '32px', 
              width: '32px',
              borderRadius: '6px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }} 
          />
          <h1 className="text-heading" style={{ fontSize: '18px', color: 'rgba(255, 255, 255, 0.9)' }}>
            FERC Regulatory Analysis Platform
            {agencyConfig.locked && (
              <span style={{ 
                fontSize: '14px', 
                marginLeft: '10px',
                padding: '2px 8px',
                background: 'rgba(255, 255, 255, 0.1)',
                borderRadius: '4px'
              }}>
                {agencyConfig.displayName}
              </span>
            )}
          </h1>
        </div>

        <div className="nav-tabs">
          <button className="nav-tab active">Regulations</button>
          <button 
            className="nav-tab" 
            disabled 
            style={{ 
              opacity: 0.5, 
              cursor: 'not-allowed',
              color: 'rgba(255, 255, 255, 0.4)'
            }}
            title="Coming soon"
          >
            Guidance (Coming Soon)
          </button>
          <button 
            className="nav-tab" 
            disabled 
            style={{ 
              opacity: 0.5, 
              cursor: 'not-allowed',
              color: 'rgba(255, 255, 255, 0.4)'
            }}
            title="Coming soon"
          >
            Incorporated by Ref (Coming Soon)
          </button>
        </div>

        <div className="header-right">
          <div className="user-info">
            <span>Administrator</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;